<template>
    <div class="sick-box" v-if="canShow('面象分析') && info && info.face_text">
        <div v-if="!isPrint">
            <div class="risk">面象分析</div>
            <div class="assessment">
                <div class="table-mark">
                    <table class="newre-table">
                        <thead>
                            <tr>
                                <th>面象指标</th>
                                <th>面象结果</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>两颊</td>
                                <td>{{ info.face_text['lian_jia'] ? info.face_text['lian_jia'] : '正常' }}</td>
                            </tr>
                            <tr>
                                <td>眼睑</td>
                                <td>{{ info.face_text['yan_jian'] ? info.face_text['yan_jian'] : '正常' }}</td>
                            </tr>
                            <tr>
                                <td>唇色</td>
                                <td>{{ info.face_text['chun_se'] ? (`${info.face_text['chun_se']}${info.face_text['chun_zi']?`（含${info.face_text['chun_zi']}色 ）`:''}`) : '正常' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div v-if="info.face_text.jiangjie && hasJiangjieAbnormal">
            <div class="face-analysis-title">{{ isPrint ? '面象' : '面象解析' }}</div>
            <div class="dotted-line"></div>
             <div v-if="getJiangjie('脸颊') && getJiangjie('脸颊').ID!==0">
                <div class="face-analysis-item" >
                    <div class="face-imgs img-width">
                        <img :src="info.face_text.images.mid_face_with_nose" alt="" @click="previewImage" />
                    </div>
                    <div class="face-title">【两颊：{{ getJiangjie('脸颊').Jieguo }}】</div>
                    <div class="face-desc">{{ getJiangjie('脸颊').Jiangjie }}</div>
                    <div v-if="getJiangjie('脸颊').Jiangkang">
                        <div class="face-subtitle">【健康指征】</div>
                        <div class="face-desc">{{ getJiangjie('脸颊').Jiangkang }}</div>
                    </div>
                </div>
                <div class="dotted-line"></div>
            </div>
            <div v-if="info.face_text.jiangjie['眼睑'] && info.face_text.jiangjie['眼睑'].ID!==0">
                <div class="face-analysis-item" >
                    <div class="face-imgs">
                        <img :src="info.face_text.images.right_eye" alt="" @click="previewImage" />
                        <img :src="info.face_text.images.left_eye" alt="" @click="previewImage" />
                    </div>
                    <div class="face-title">【眼睑：{{ info.face_text.jiangjie['眼睑'].Jieguo }}】</div>
                    <div class="face-desc">{{ info.face_text.jiangjie['眼睑'].Jiangjie }}</div>
                    <div v-if="info.face_text.jiangjie['眼睑'].Jiangkang">
                        <div class="face-subtitle">【健康指征】</div>
                        <div class="face-desc">{{ info.face_text.jiangjie['眼睑'].Jiangkang }}</div>
                    </div>
                </div>
                <div class="dotted-line"></div>
            </div>
            <div v-if="info.face_text.jiangjie['唇色'] && info.face_text.jiangjie['唇色'].ID!==0">
                <div class="face-analysis-item" >
                    <div class="face-imgs">
                        <img :src="info.face_text.images.lips" alt="" @click="previewImage" />
                    </div>
                    <div class="face-title">【唇色：{{ info.face_text.jiangjie['唇色'].Jieguo }}】</div>
                    <div class="face-desc">{{ info.face_text.jiangjie['唇色'].Jiangjie }}</div>
                    <div v-if="info.face_text.jiangjie['唇色'].Jiangkang">
                        <div class="face-subtitle">【健康指征】</div>
                        <div class="face-desc">{{ info.face_text.jiangjie['唇色'].Jiangkang }}</div>
                    </div>
                </div>
                <div class="dotted-line"></div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import { moduleMixin } from '../helpers';
import { ImagePreview } from 'vant';

export default {
    name: 'ReportFace',
    mixins: [moduleMixin],
    computed: {
        ...mapState('report', ['info']),
        hasJiangjieAbnormal() {
            const j = this.info && this.info.face_text && this.info.face_text.jiangjie;
            if (!j) return false;
            return ['脸颊', '眼睑', '唇色'].some((key) => {
                const item = this.getJiangjie(key);
                return item && item.ID !== 0;
            });
        }
    },
    methods: {
        // 从 jiangjie 中取值，兼容同义词 key
        getJiangjie(key) {
            const j = this.info && this.info.face_text && this.info.face_text.jiangjie;
            if (!j) return undefined;
            const keys = {
                '脸颊': ['脸颊', '双颊', '两颊'],
                '眼睑': ['眼睑'],
                '唇色': ['唇色'],
            };
            const list = keys[key];
            if (list) {
                for (const k of list) {
                    if (j[k] != null) return j[k];
                }
            }
            return j[key];
        },
        previewImage(e) {
            const container = e.target.parentNode;
            const imgElements = container.querySelectorAll('img');
            const images = [];
            let startPosition = 0;
            
            imgElements.forEach((img) => {
                const src = img.getAttribute('src');
                if (src) {
                    images.push(src);
                    if (img === e.target) {
                        startPosition = images.length - 1;
                    }
                }
            });

            if (images.length > 0) {
                ImagePreview({
                    images,
                    startPosition
                });
            }
        }
    }
};
</script>
<style lang="scss" scoped>
@import './Face.scss';
</style>
